// 📁 frontend/src/pages/PrintOrderPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../axios';

export default function PrintOrderPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await axios.get(`/api/orders/${orderId}`);
        setOrder(response.data.order);
        setTimeout(() => window.print(), 500);
      } catch (error) {
        console.error("فشل في جلب الطلب للطباعة:", error);
      }
    };
    fetchOrder();
  }, [orderId]);

  if (!order) {
    return <p style={{ textAlign: 'center', marginTop: '30px' }}>جاري تحميل الفاتورة...</p>;
  }

  return (
    <div style={styles.receipt}>
      {/* رأس الفاتورة */}
  <div style={styles.centerText}>
  <h1 style={styles.storeName}>مطعم الأصالة</h1>
  <br></br>
  <h3 style={{ marginTop: '-10px' }}>للأكلات السريعة</h3>
  <p>فاتورة طلب رقم: {order.id}</p>
</div>

      <div style={styles.divider} />

      {/* بيانات العميل والطلب */}
      <p><strong>👤 الاسم:</strong> {order.customer_name || 'غير متوفر'}</p>
      <p><strong>📞 الهاتف:</strong> {order.phone}</p>

      {order.delivery_method === 'delivery' ? (
        <>
          <p><strong>📍 المنطقة:</strong> {order.delivery_zone?.name || 'غير محدد'}</p>
          <p><strong>🏠 العنوان:</strong> {order.address || 'غير متوفر'}</p>
        </>
      ) : (
        <p><strong>نوع الطلب:</strong> 🍽️ داخل المطعم</p>
      )}

      <p><strong>نوع الطلب:</strong> {order.delivery_method === 'delivery' ? '🚚 توصيل' : '🍽️ داخلي'}</p>

      <div style={styles.divider} />

      {/* تفاصيل الطلب */}
      <p style={styles.sectionTitle}>تفاصيل الطلب:</p>
      {order.items.map((item, index) => (
        <div key={index} style={styles.item}>
          <div>
            {item.name} × {item.quantity}
            <br />
            <small>السعر: {item.total_price} ₪</small>
          </div>

          {/* خيارات/إضافات المنتج */}
          {item.selected_options && Object.keys(item.selected_options).length > 0 && (
            <ul style={styles.optionsList}>
              {Object.values(item.selected_options).flat().map((opt, idx) => (
                <li key={idx} style={styles.optionItem}>
                  - {opt.name} (+{opt.price_diff} ₪)
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}

      <div style={styles.divider} />

      {/* مجموع الفاتورة */}
      <div style={styles.totalRow}>
        <span>المجموع الفرعي:</span>
        <span>{order.subtotal} ₪</span>
      </div>
      {order.delivery_fee > 0 && (
        <div style={styles.totalRow}>
          <span>رسوم التوصيل:</span>
          <span>{order.delivery_fee} ₪</span>
        </div>
      )}
      <div style={{ ...styles.totalRow, fontWeight: 'bold' }}>
        <span>الإجمالي:</span>
        <span>{order.total} ₪</span>
      </div>

      <div style={styles.divider} />

      {/* الملاحظات */}
      {order.notes && (
        <>
          <p><strong>📝 ملاحظات:</strong> {order.notes}</p>
          <div style={styles.divider} />
        </>
      )}

      {/* التذييل */}
      <p style={styles.centerText}>شكراً لتعاملكم معنا</p>
      <p style={styles.centerText}>تاريخ الطباعة: {new Date().toLocaleString()}</p>

      {/* طباعة بالأبيض والأسود */}
      <style>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact;
            }
            * {
              filter: grayscale(100%) !important;
            }
          }
        `}
      </style>
    </div>
  );
}

const styles = {
  receipt: {
    width: '80mm',
    padding: '6px',
    fontFamily: "'Cairo', sans-serif",
    fontSize: '12px',
    direction: 'rtl',
    color: '#000',
    backgroundColor: '#fff',
  },
  centerText: {
    textAlign: 'center',
    lineHeight: '1.4',
  },
  storeName: {
    margin: 0,
    fontSize: '18px',
    fontWeight: '900',
  },
  divider: {
    borderTop: '1px dashed #000',
    margin: '6px 0',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '700',
    margin: '8px 0 5px',
  },
  item: {
    marginBottom: '8px',
  },
  optionsList: {
    margin: '3px 0 0 16px',
    padding: 0,
    listStyle: 'none',
  },
  optionItem: {
    fontSize: '11px',
    color: '#333',
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '4px',
    fontSize: '13px',
  },
};
